export const ALL_PRODUCTS = 'ALL_PRODUCTS'
export const ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS'

export const PRODUCT_BY_ID = 'PRODUCT_BY_ID'
export const PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS'

export const ADD_PRODUCT = 'ADD_PRODUCT'
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS'

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS'

export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const REMOVE_PRODUCT_SUCCESS = 'REMOVE_PRODUCT_SUCCESS'

export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CLEAR_CART = 'CLEAR_CART'

export const ALL_MANUFACTURERS = 'ALL_MANUFACTURER'
export const ALL_MANUFACTURERS_SUCCESS = 'ALL_MANUFACTURER_SUCCESS'

export const ALL_CATEGORIES = 'ALL_CATEGORIES'
export const ALL_CATEGORIES_SUCCESS = 'ALL_CATEGORIES_SUCCESS'

export const ALL_CALENDARS = 'ALL_CALENDARS'
export const ALL_CALENDARS_SUCCESS = 'ALL_CALENDARS_SUCCESS'

export const SPINNER_SHOW = 'SPINNER_SHOW'
export const SPINNER_HIDE = 'SPINNER_HIDE'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js